module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/390.6fb2e82d.png";